<template>
    <MenuBaseSubmenu :listenerId="listenerId">
        <a :href="getLink('backlinks') + statusFilterHash" :class="{active: currentReport === 'backlinks'}">
            <span>{{ $t('lang.menu.search.links.backlinks') }}</span>
        </a>
        <a :href="getLink('outlinks') + statusFilterHash" :class="{active: currentReport === 'outlinks'}">
            <span>{{ $t('lang.menu.search.links.outlinks') }}</span>
        </a>
        <a :href="getLink('backlinks-domains')" :class="{active: currentReport === 'backlinks-domains'}">
            <span>{{ $t('lang.menu.search.links.backlinks_domains') }}</span>
        </a>
        <a :href="getLink('outlinks-domains')" :class="{active: currentReport === 'outlinks-domains'}">
            <span>{{ $t('lang.menu.search.links.outlinks_domains') }}</span>
        </a>
        <a :href="getLink('backlinks-ip')" :class="{active: currentReport === 'backlinks-ip'}">
            <span>{{ $t('lang.menu.search.links.backlinks_ip') }}</span>
        </a>
        <a :href="getLink('backlinks/toppages')" :class="{active: currentReport === 'backlinks/toppages'}">
            <span>{{ $t('lang.menu.search.links.backlinks_toppages') }}</span>
        </a>
        <a :href="getLink('backlinks-anchor')" :class="{active: currentReport === 'backlinks-anchor'}">
            <span>{{ $t('lang.menu.search.links.backlinks_anchor') }}</span>
        </a>
    </MenuBaseSubmenu>
</template>

<script>
import {Listeners} from "../../../constants/listeners";
import MenuBaseSubmenu from "./BaseSubmenu.vue";
import Submenu from "../mixins/Submenu";

export default {
    name: "MenuSubmenuLinks",
    mixins: [Submenu],
    props: {
        domain: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            listenerId: Listeners.TOP_MENU_LINKS_HOVER,
            // Предустановленный фильтр "рабочие ссылки" (status=1).
            // Двойное кодирование: KSFilter декодирует хэш дважды, см. restoreFilter() в KSFilter.vue
            statusFilterHash: '#filter=status%253D1',
        };
    },
    components: {
        MenuBaseSubmenu,
    },
}
</script>
